module.exports = __webpack_public_path__ + "static/media/preview2-small.aba929ef.jpg";